/*
  all the constants related to create function feature
  will reside here
*/

export const clientSideImports = ['axios', 'moment']
export const imports = ['moment', 'bluebird', 'ajv', 'axios']

export const a8flowFunctions = [
  'evaluateDMN',
  'getNextAvailableAgent',
  'dedupe',
  'getUsers',
  'getUserById',
  'getUsersByGroupId',
  'getGroups',
  'getGroupById',
  'getProcessDefinitions',
  'startNewProcessInstance',
  'startNewProcessInstanceByAppId',
  'getLoggedInUser',
  'generateSequenceId',
  'eventLogger',
  'getSignedURL',
  'setDueDateAndFollowUpDate',
  'getGroupsByUserId',
  'generateChecksum',
  'sendMail',
  'getAssignee',
  'sendMessage'
]

export const a8AstroFunctions = [
  'connect',
  'create',
  'createMany',
  'find',
  'update',
  'delete',
]

export const permissions = {
  a8config: ['getConfig'],
  a8flow: a8flowFunctions,
  a8Astro: a8AstroFunctions,
  a8func: [],
}

export const defaultSource = `async function main(params) {
  // Start of editable area

  // End of editable area
}`

export const gcfEndpoint =
  'https://us-central1-a8platformdev.cloudfunctions.net/a8codeExecutor'
